import { Category, IConsultation } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import Link from 'next/link';
import styles from './CategoriesSection.module.scss';
import Button, { ButtonVariants } from '../../../components/Button';
import CategoryPosts from './CategoryPosts';
import Consultation from '../../Home/Consultation';
import AnimatedTitle from '../../../components/AnimatedTitle';
import DynamicHeading from '../../../components/DynamicHeading';
import { SubmitType } from '../../Home/Consultation/ConsultationForm';

const ViewAllButton = ({ slug }: { slug: string }) => (
  <Button
    link={`blog/category/${slug}`}
    variant={ButtonVariants.TRANSPARENT}
    className={styles.categoryButton}
    icon={(
      <svg
        height={24}
        width={24}
      >
        <use
          href='/media/icon-nest.svg#iconNest'
          xlinkHref='/media/icon-nest.svg#iconNest'
        />
      </svg>
        )}
  >
    view all
  </Button>
);

const CategoryBlock = ({
  category,
  index,
  className,
  containerModifier = '',
  headerLevel = 'h3',
  withoutLink,
}: {
  category: Category;
  index: number;
  className?: string;
  containerModifier?: string;
  headerLevel?: 'h2' | 'h3';
  withoutLink?: boolean;
}) => {
  const showNewsletterBlock = index === 1;
  return (
    <>
      <div className={classNames(styles.categoryBlock, className)}>
        <div className={classNames(styles.categoryHead, 'container', containerModifier)}>
          <DynamicHeading
            headingTag={headerLevel}
            className={classNames(styles.categoryTitle, { title3: headerLevel === 'h3' }, styles[containerModifier])}
          >
            {withoutLink ? <AnimatedTitle title={category.title} /> : (
              <Link
                href={`blog/category/${category.slug}`}
              >
                <AnimatedTitle title={category.title} />
              </Link>
            )}
          </DynamicHeading>
          <ViewAllButton
            slug={category.slug}
          />
        </div>
        <CategoryPosts
          posts={category.posts}
          index={index}
          gridClassName={containerModifier}
        />
        <div className={classNames(styles.categoryFooter, 'container', containerModifier)}>
          <ViewAllButton slug={category.slug} />
        </div>
      </div>
      {showNewsletterBlock && (
        <Consultation
          data={{
            title: 'Subscribe to our **newsletter!**',
            description: 'Get the latest tech trends, expert insights, and success stories delivered to your inbox.',
          } as IConsultation}
          type={SubmitType.NEWSLETTER}
        />
      )}
    </>
  );
};

export default CategoryBlock;
